import { helper } from "../utils/helper";
import report from "../utils/report";
function getJSError(e) {
  try {
    var target = e.target || e.srcElement;
    var message = e.message || '';
    var isElementTarget = target instanceof HTMLScriptElement || target instanceof HTMLLinkElement || target instanceof HTMLImageElement;
    if (!isElementTarget) {
      report({
        logType: 'error',
        title: 'js-error-addeventlistener',
        msg: message,
        extra: {}
      });
      return false;
    }
    // 页面静态资源加载错误处理
    var typeName = target.localName;
    var sourceUrl = target.src || target.href;
    if (window.location.href.indexOf(sourceUrl) !== 0) {
      setTimeout(function () {
        report({
          logType: 'error',
          title: 'source-error',
          msg: sourceUrl,
          extra: {
            typeName: typeName,
            sourceUrl: sourceUrl
          }
        });
      }, 2000);
    }
  } catch (error) {
    helper.console.log(error);
  }
}
export function onMonitor() {
  /**
   * js运行时错误,
   * 使用window.onerror和window.addEventListener('error')都能捕获，
   * 但是window.onerror含有详细的error堆栈信息，存在error.stack中，
   * 所以我们选择使用onerror的方式对js运行时错误进行捕获
   */
  window.addEventListener('error', function (e) {
    getJSError(e);
  }, true);
  window.onerror = function (errorMsg, url, lineNumber, columnNumber, errorObj) {
    try {
      // 报错堆栈信息中包含换行符，由于一条日志只能包含一行完整文本，因此对换行符做 escape 处理
      var errorStack = errorObj ? errorObj.stack.replaceAll('\n', '\\n') : null;
      report({
        logType: 'error',
        title: 'js-error-onerror',
        msg: errorMsg,
        extra: {
          errorObj: errorObj,
          url: url,
          lineNumber: lineNumber,
          columnNumber: columnNumber,
          errorStack: errorStack
        }
      });
    } catch (error) {
      helper.console.log(error);
    }
  };
  window.onunhandledrejection = function (e) {
    try {
      if (e !== null && e !== void 0 && e.promise) {
        var _e$promise;
        (_e$promise = e.promise) === null || _e$promise === void 0 ? void 0 : _e$promise.catch(function (err) {
          report({
            logType: 'error',
            title: 'promise-error',
            msg: {
              message: err.message,
              stack: err.stack
            },
            extra: {}
          });
        });
      }
    } catch (error) {
      helper.console.log(error);
    }
  };
}